import { ProductSpecsProduct } from './ProductSpecsWrapper.types'

export const getProductSpecs = (product: any): ProductSpecsProduct => {
  const productData: ProductSpecsProduct = {
    color: product?.c_color2,
    materials: product?.c_material,
    height: product?.c_height,
    width: product?.c_width,
    depth: product?.c_depth,
    plugType: product?.c_plugTyp,
    capsuleWarning: product?.c_capsuleWarning,
    capacity: product?.c_capacity,
    energySavingMode: product?.c_energySavingMode,
    voltageRating: product?.c_voltageRating,
    tempAdjustmant: product?.c_tempAdjustmant,
    strengthAdjustment: product?.c_strengthAdjustment,
    quantityAdjustment: product?.c_quantityAdjustment,
    modelVersion: product?.c_version,
    weeeNumber: product?.c_weee,
    waterTankSensor: product?.c_waterTankSensor,
    waterHardness: product?.c_waterHardness
  }

  // clean object of undefined or null values
  const cleanProductData = Object.fromEntries(
    Object.entries(productData).filter(
      ([_, v]) =>
        v !== null && typeof v !== 'undefined' && v.toString().length > 0
    )
  )

  return cleanProductData
}
